const userActionTypes = {
    SET_CURRENT_USER: 'SET_CURRENT_USER',
    SET_COLOR_THEME: 'SET_COLOR_THEME',
    CLEAR_ALL: 'CLEAR_ALL'
};

export default userActionTypes;